// reducers/homeworkReducer.js
export const homeworkReducer = (state = { homework: [] }, action) => {
  switch (action.type) {
    case "HOMEWORK_REQUEST":
      return { ...state, loading: true };
    case "GET_HOMEWORK_SUCCESS":
      return { loading: false, homework: action.payload };
    case "CREATE_HOMEWORK_SUCCESS":
      return { loading: false, success: true };
    case "SUBMIT_HOMEWORK_SUCCESS":
      return { loading: false, submitted: true };
    case "DELETE_HOMEWORK_SUCCESS":
      return {
        ...state,
        loading: false,
        homework: (state.homework || []).filter((h) => h.id !== action.payload),
      };
    case "HOMEWORK_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false, submitted: false };
    default:
      return state;
  }
};
